import React, {Component} from "react";
import PropTypes from "prop-types";
import {_countPaidUsers} from "../../../../../services/apis/StatisticsAPI";

class PaidUsers extends Component {
    state = {
        total: 0,
        loading: false
    };

    componentDidMount() {
        this._fetchTotalPaidUsers();
    }

    _fetchTotalPaidUsers = () => {
        this.setState({
            loading: true
        });

        _countPaidUsers()
            .then(response => {
                const {success, data} = response;

                const updateState = {
                    loading: false
                };

                if (success) {
                    updateState.total = data;
                }

                this.setState(updateState);
            })
            .catch(error => {
                this.setState({
                    loading: false
                });
            });
    };

    render() {
        const {total, loading} = this.state;

        return (
            <div className="PaidUsers">
                <hr/>
                Paid users: {loading ? 'loading...' : <strong>{total}</strong>} users
            </div>
        );
    }
}

PaidUsers.propTypes = {
    any: PropTypes.any
};

export default PaidUsers;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/statistic/PaidUsers/PaidUsers.js